import React from 'react';
import HomePage from './HomePage';
import './App.css'; // If you have a global stylesheet for your app, you can import it here

function App() {
  return (
    <div className="App">
      {/* Main content of the application */}
      <HomePage />
    </div>
  );
}

export default App;
